export interface ITenantTimezone {
  id: number;
  timezoneId: string;
  isDefault: boolean;
  isDeleted: boolean;
}

const asRecord = (value: unknown): Record<string, unknown> | null =>
  value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;

const pickString = (
  record: Record<string, unknown>,
  ...keys: string[]
): string => {
  for (const key of keys) {
    const value = record[key];
    if (typeof value === 'string' && value.trim()) return value.trim();
  }
  return '';
};

const pickId = (record: Record<string, unknown>): number => {
  const raw = record.id ?? record.Id;
  if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
  if (typeof raw === 'string' && raw.trim()) {
    const parsed = Number.parseInt(raw, 10);
    if (Number.isFinite(parsed)) return parsed;
  }
  return 0;
};

export const parseTenantTimezones = (payload: unknown): ITenantTimezone[] => {
  if (!Array.isArray(payload)) return [];
  return payload.flatMap((item) => {
    const record = asRecord(item);
    if (!record) return [];
    const timezoneId = pickString(
      record,
      'timezoneId',
      'TimezoneId',
      'name',
      'Name'
    );
    if (!timezoneId) return [];
    return [
      {
        id: pickId(record),
        timezoneId,
        isDefault: Boolean(record.isDefault ?? record.IsDefault),
        isDeleted: record.isDeleted === true || record.IsDeleted === true,
      },
    ];
  });
};

export const toTenantTimezonePayload = (
  selectedIds: string[],
  defaultId: string,
  previous: ITenantTimezone[]
): ITenantTimezone[] => {
  const previousById = new Map(previous.map((item) => [item.timezoneId, item]));
  const ids = [...new Set(selectedIds.map((id) => id.trim()).filter(Boolean))];
  const nextDefault = ids.includes(defaultId) ? defaultId : '';
  return ids.map((timezoneId) => ({
    id: previousById.get(timezoneId)?.id ?? 0,
    timezoneId,
    isDefault: timezoneId === nextDefault,
    isDeleted: false,
  }));
};
